import React from 'react'
import loading from "../loading.gif"
function Loading() {
    return (
        <div className="container-fluid">
        <h1>Currently Loading Your Content ...</h1>
            <img src={loading} alt="loading gif"/>
        </div>
    )
}

export default Loading
